import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import NotFound from "../utility/NotFound";
import MarkdownViewer from "../../components/utilities/MarkdownViewer";
import { Box, Container, Button, Link, Grid } from "@mui/material";
import moment from "moment";
import "moment-timezone";
import PageHeader from "../../components/layout/PageHeader";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { getData } from "../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const SUPPORTS_CMS = getEnvironmentVariable("SUPPORTS_CMS") === "true";

export default function PostViewer() {
  const [loading, setLoading] = useState(true);
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);
  const [, setScreenWidth] = useState(window.innerWidth);
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const go = async () => {
      try {
        let apiPost = await getData(`/pages/${postId}`, {
          env: getEnvironmentVariable("COMPANY_FLAG"),
          "expand[]": ["headerImage", "featuredImage"],
        });

        if (postId && apiPost.status === "published") {
          setPost(apiPost);
          setAdminLoggedIn(authContext?.authState?.identity?.isAdmin === true);
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
      }

      setLoading(false);
    };

    if (!SUPPORTS_CMS) {
      setError(true);
      return;
    }

    go();
    // eslint-disable-next-line
  }, [postId]);

  useEffect(() => {
    function handleResize() {
      setScreenWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
  });

  if (error) {
    return <NotFound />;
  }

  if (loading) {
    return <ModalLoadingFull />;
  }

  return (
    <>
      {Boolean(loading) && <ModalLoadingFull />}

      <PageHeader
        title={post?.title}
        subTitle={post?.subTitle}
        subTitle2={
          post?.pageType === "post" && post?.sortDate
            ? moment(post?.sortDate).format("DD MMM YYYY")
            : null
        }
        headerImage={{
          url: post.headerImage?.cloudFrontDomain
            ? `${post.headerImage.cloudFrontDomain}${
                post.headerImage.sizes?.large || post.headerImage.filename
              }`
            : post?.featuredImage?.cloudFrontDomain
            ? `${post.featuredImage.cloudFrontDomain}${
                post.featuredImage.sizes?.large || post.featuredImage.filename
              }`
            : null,
        }}
      />

      <Box width="100%">
        <Container
          maxWidth="lg"
          sx={{
            pt: 2,
            pb: 2,
          }}
        >
          <Grid container gap={2} sx={{ p: 2 }}>
            {post?.body && (
              <Grid item xs={12}>
                <MarkdownViewer source={post?.body} />
              </Grid>
            )}

            {post?.tags?.length > 0 && (
              <Grid item xs={12} p={2}>
                <Box
                  sx={{
                    "& a:not(:first-of-type)": {
                      ml: 1,
                    },
                  }}
                >
                  {post.tags.map((tag, index) => {
                    return (
                      <Link key={index} href={`/news/${tag}`}>
                        {`#${tag}`}
                      </Link>
                    );
                  })}
                </Box>
              </Grid>
            )}

            <Grid item xs={12} p={2}>
              {adminLoggedIn && (
                <>
                  <Button variant="contained" href={`/cms/post/${post.id}`}>
                    Edit Post
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
